import { mapValues } from 'lodash';
import * as lexicalHelpers from 'modules/Lexical/helpers';
import * as Models from 'models';
import { isTextComponent } from 'utils/entityType';
import { toJS } from 'utils/immutable';
import { formatProjectMetadataDates } from 'utils/projectMetadata/formatProjectMetadataDates';

type UpdateExistingProjectMetadataTokensArgs =
  Models.GetProjectDataProcessArgs
  | Models.RefreshProcessArgs;

export function updateExistingProjectMetadataTokens<T extends UpdateExistingProjectMetadataTokensArgs>(
  args: T,
): T {
  const metadata = formatProjectMetadataDates(toJS(args.assets.rootDocument));
  const {
    assets: {
      documents,
    },
  } = args;

  args.assets.documents = mapValues(documents, (document) => {
    if (isTextComponent(document)) {
      return lexicalHelpers.updateProjectMetadataTokens(document, metadata);
    }

    return document;
  });

  return args;
}
